export const tr = {
    'select-ad-platforms': 'Reklam platformu seçimi',
    'select-ad-platforms-diff-group':
        'Reklam platformları seçin. Formatları dikkate alın, uygun boyutta kreatifleri olan platformlar ekleyin. Aynı anda birden fazla şehirde platform seçebilirsiniz.'
};
